export const REGION_CODE = {
  // Selatan
  'Banjarmasin Selatan': '63.71.01',
  'Mantuil': '63.71.01.1001',
  'Kelayan Selatan': '63.71.01.1002',
  'Pekauman': '63.71.01.1003',
  'Kelayan Barat': '63.71.01.1004',
  'Kelayan Tengah': '63.71.01.1005',
  'Kelayan Dalam': '63.71.01.1006',
  'Murung Raya': '63.71.01.1007',
  'Kelayan Timur': '63.71.01.1008',
  'Tanjung Pagar': '63.71.01.1009',
  'Pemurus Dalam': '63.71.01.1010',
  'Pemurus Baru': '63.71.01.1011',
  'Basirih Selatan': '63.71.01.1012',

  // Timur
  'Banjarmasin Timur': '63.71.02',
  'Kuripan': '63.71.02.1001',
  'Kebun Bunga': '63.71.02.1002',
  'Karang Mekar': '63.71.02.1003',
  'Sungai Bilu': '63.71.02.1004',
  'Sungai Lulut': '63.71.02.1005',
  'Banua Anyar': '63.71.02.1006',
  'Pengambangan': '63.71.02.1007',
  'Pekapuran Raya': '63.71.02.1008',
  'Pemurus Luar': '63.71.02.1009',

  // Barat
  'Banjarmasin Barat': '63.71.03',
  'Belitung Utara': '63.71.03.1001',
  'Belitung Selatan': '63.71.03.1002',
  'Pelambuan': '63.71.03.1003',
  'Telaga Biru': '63.71.03.1004',
  'Telawang': '63.71.03.1005',
  'Teluk Tiram': '63.71.03.1006',
  'Kuin Selatan': '63.71.03.1007',
  'Kuin Cerucuk': '63.71.03.1008',
  'Basirih': '63.71.03.1009',

  // Utara
  'Banjarmasin Utara': '63.71.04',
  'Alalak Tengah': '63.71.04.1001',
  'Alalak Utara': '63.71.04.1002',
  'Alalak Selatan': '63.71.04.1003',
  'Sungai Jingah': '63.71.04.1004',
  'Sungai Miai': '63.71.04.1005',
  'Surgi Mufti': '63.71.04.1006',
  'Pangeran': '63.71.04.1007',
  'Antasan Kecil Timur': '63.71.04.1008',
  'Kuin Utara': '63.71.04.1009',
  'Sungai Andai': '63.71.04.1010',

  // Tengah
  'Banjarmasin Tengah': '63.71.05',
  'Kertak Baru Ilir': '63.71.05.1001',
  'Kertak Baru Ulu': '63.71.05.1002',
  'Mawar': '63.71.05.1003',
  'Teluk Dalam': '63.71.05.1004',
  'Antasan Besar': '63.71.05.1005',
  'Pasar Lama': '63.71.05.1006',
  'Seberang Mesjid': '63.71.05.1007',
  'Gadang': '63.71.05.1008',
  'Melayu': '63.71.05.1009',
  'Sungai Baru': '63.71.05.1010',
  'Pekapuran Laut': '63.71.05.1011',
  'Kelayan Luar': '63.71.05.1012'
}